import Vue from "vue";
Vue.component(`paging`, (resolve) =>
    require(["../../components/common/modules/paging.vue"], resolve)
);
 //分页组件
Vue.component(`v-date`, (resolve) =>
    require(["../../components/common/modules/date.vue"], resolve)
); //分页组件
Vue.component(`v-notDate`, (resolve) =>
    require(["../../components/common/modules/notDate.vue"], resolve)
); //分页组件
Vue.component(`v-historyDate`, (resolve) =>
    require(["../../components/common/modules/historyDate.vue"], resolve)
); //分页组件
Vue.component(`v-editor`, (resolve) =>
    require(["../../components/common/modules/editor.vue"], resolve)
); //富文本编辑器组件
Vue.component(`v-drawer`, (resolve) =>
    require(["../../components/common/drawer.vue"], resolve)
); //富文本编辑器组件
Vue.component(`v-payment`, (resolve) =>
    require(["../../components/common/modules/payment.vue"], resolve)
); //富文本编辑器组件